import type { Sala, SalaFormValues, SalaWritePayload } from './sala';

// SalasListPage.jsx:78-83 — coincidencia por id/name/datacenterName, case-insensitive.
export function filterSalas(
  salas: Sala[],
  filter: { query: string; datacenterId: string },
): Sala[] {
  const query = filter.query.toLowerCase();
  return salas.filter((s) => {
    const matchesQuery =
      s.id.toLowerCase().includes(query) ||
      s.name.toLowerCase().includes(query) ||
      (s.datacenterName?.toLowerCase().includes(query) ?? false);
    const matchesDc = filter.datacenterId === 'all' || s.datacenterId === filter.datacenterId;
    return matchesQuery && matchesDc;
  });
}

// SalasListPage.jsx:61-62 — omite status si es 'all' (asimetría as-is con datacenters).
export function buildSalaListParams(status: string): { status?: string } {
  return status === 'all' ? {} : { status };
}

// SalaFormPage.jsx:20-82 — mapeo 1:1 sin normalización, sin status/isWarehouse.
export function toSalaWritePayload(form: SalaFormValues): SalaWritePayload {
  return {
    datacenterId: form.datacenterId,
    name: form.name,
  };
}
